module.exports = __webpack_public_path__ + "static/kasia_kowalska-7df76a06299c8587b4410002982c77f7.jpg";